import Esrever from 'esrever';
import type { Descendant } from 'slate';
import { Editor, Element, Node } from 'slate';

import type { FakeElement, RenderModelLine } from '../internal';
import { isBreakingSpace, measureText } from '../internal';

interface LeadingSpacesState {
  done: boolean;
  width: number;
}

export function leadingSpacesWidthInLinePx(
  editor: Editor,
  line: Pick<RenderModelLine, 'children'>
): number {
  const fakeElement: FakeElement = { children: line.children, suggestedEdits: [], type: 'fake' };
  const reverseLineChildrenEntries = [...Node.nodes(fakeElement, { reverse: true })];
  const filteredNodeEntries = reverseLineChildrenEntries.filter(([n]) => n !== line);
  const leadingSpacesState: LeadingSpacesState = {
    done: false,
    width: 0,
  };

  for (const [lineChild] of filteredNodeEntries) {
    if (Editor.isEditor(lineChild)) continue;

    resolveSpacesWidth(editor, { leadingSpacesState, lineChild });
    if (leadingSpacesState.done) break;
  }

  return leadingSpacesState.width;
}

export function resolveSpacesWidth(
  editor: Editor,
  options: {
    leadingSpacesState: LeadingSpacesState;
    lineChild: Descendant;
  }
): void {
  const { leadingSpacesState, lineChild } = options;
  if (Element.isElement(lineChild)) {
    const reverseInlineEntries = [...Node.nodes(lineChild, { reverse: true })];
    const filteredNodeEntries = reverseInlineEntries.filter(([n]) => n !== lineChild);

    for (const [inline] of filteredNodeEntries) {
      if (Editor.isEditor(inline)) continue;

      resolveSpacesWidth(editor, { leadingSpacesState, lineChild: inline });
      if (leadingSpacesState.done) return;
    }
  } else {
    const reverseText = Esrever.reverse(lineChild.text);
    const reverseCharacters = reverseText.split('');

    for (const char of reverseCharacters) {
      if (!isBreakingSpace(char)) {
        leadingSpacesState.done = true;
        return;
      }

      leadingSpacesState.width += measureText(editor, {
        suppressJustifiedWarning: true,
        text: char,
        textNode: lineChild,
      });
    }
  }
}
